import { c } from '#/shared'
import { useModal } from '../model'
import styles from './template.module.scss'
import PlusIcon from '#/assets/svg/plus.svg?react'

export type AlignX = 'left' | 'center' | 'right'
export type AlignY = 'top' | 'center' | 'bottom'
export type Variant = 'primary' | 'secondary'

export interface PlatesTemplateProps {
	id: string
	children: React.ReactNode
	title?: string
	closeModal?: () => void
	hasTemplate?: boolean
	hasBg?: boolean
	alignX?: AlignX
	alignY?: AlignY
	animationClass?: string
	animationBehaviorClass?: string
	headerClassName?: string
	/** Перекрывает фон контента плашки (например `#151518`) */
	contentBackgroundColor?: string
	variant?: Variant
}

export default function PlatesTemplate({
	id,
	title,
	children,
	alignX = 'center',
	alignY = 'center',
	hasTemplate = true,
	hasBg = true,
	animationClass = styles['template__animation'],
	animationBehaviorClass = styles['template__animation-behavior'],
	closeModal = () => {},
	headerClassName,
	contentBackgroundColor,
	variant = 'primary',
}: PlatesTemplateProps) {
	const modal = useModal(id)

	return (
		<div
			className={c(
				styles['template'],
				modal.state ? styles['template_visible'] : styles['template_invisible'],
				hasBg ? styles['template_flex'] : styles['template_w-fit'],
				styles[`template_align-y-${alignY}`],
				hasBg ? styles[`template_align-x-${alignX}`] : ''
			)}
			onClick={() => {
				if (hasBg) modal.setState(false)
			}}
		>
			{hasTemplate ? (
				<div
					className={c(
						styles['template__content'],
						animationClass,
						modal.state ? '' : animationBehaviorClass,
						styles[`template__content_${variant}`],
						contentBackgroundColor && styles['template__content_customBg']
					)}
					style={
						contentBackgroundColor
							? ({ '--template-content-bg': contentBackgroundColor } as React.CSSProperties)
							: undefined
					}
					onClick={(e) => e.stopPropagation()}
				>
					<button
						className={c(styles['template__close-button'])}
						onClick={() => {
							modal.setState(false)
							closeModal()
						}}
					>
						<PlusIcon color={'#A4AAB5'} width={20} height={20} className={c(styles['template__icon'])} />
					</button>
					<div className={c(styles['template__content-body'])}>{children}</div>
				</div>
			) : (
				<div className={c(animationClass, modal.state ? '' : animationBehaviorClass)}>{children}</div>
			)}
		</div>
	)
}
